// extracted by mini-css-extract-plugin
module.exports = {"container":"SecuredFieldsFormSkeleton_container__gNQV_","field":"SecuredFieldsFormSkeleton_field__uf38d"};